import React, { useState } from 'react'
import StripeCheckout from 'react-stripe-checkout';
import Spinner from '../loader/loader'

function Checkout(){

    const [product, setProduct] = useState({
        name: "Analytica Monthly Subscription",
        price: 5000,
        productBy: "Analytica LLC"
    })


    const handleToken = token => {
        const body = {
            token,
            product
        }

        const headers = {
            "Content-Type": "application/json"
        }

        return fetch('http://localhost:8000/checkout', {
            method: "POST",
            headers,
            body: JSON.stringify(body)
        }).then(res => {
            console.log(res)
            const { status } = res
            console.log(status)
        })
            .catch(err => console.log(err))

    }

    return (
        <div className="App">
            <StripeCheckout
                stripeKey="pk_test_MgxBOTnkoRxU57l6fxTdOMwk00odYipeVq"
                token={handleToken}
                name="Analytica LLC"
                description="Analytics for your product reviews"
                image="https://www.smartdatacollective.com/wp-content/uploads/2018/11/top-7-data-analytics-tools-2019-768x501.jpg"
                panelLabel="Pay "
                amount={product.price * 100}
                currency="INR"
                billingAddress={true}
            >
                <button className="btn-large blue">Get Monthly Subscription for {product.price}$</button>
            </StripeCheckout>
            <Spinner />
        </div>
    );

}

export default Checkout